<template>
  <div class="nota-container">
    <CardIeaAppMain colorCard="transparent" title="" class="premium-wrapper">
      <v-col cols="12" class="pa-0">
        
        <!-- Hero Header -->
        <div class="hero-header glass-panel mb-4 py-3 px-6 mx-4 mt-4">
          <div class="d-flex align-center justify-space-between w-100">
            <div class="d-flex align-center">
              <v-btn icon dark color="primary" class="mr-4 glass-btn" @click="$router.go(-1)">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <div>
                <h1 class="text-h5 font-weight-bold primary-text mb-0">Mis Calificaciones</h1>
                <p class="text-caption grey--text text--darken-1 mb-0">Rendimiento Académico</p>
              </div>
            </div>
            <v-icon size="48" color="primary" class="opacity-30">mdi-text-box-check-outline</v-icon>
          </div>
        </div>

        <!-- Main Content -->
        <v-card class="glass-card rounded-xl overflow-hidden mx-4 mb-4" elevation="10">
          <div class="pa-6 content-area bg-light">
            
            <!-- Materias Cursando Actual -->
            <div class="mb-8">
              <h2 class="text-h6 font-weight-bold primary-text mb-4">
                <v-icon color="primary" class="mr-2">mdi-book-open-variant</v-icon>
                {{ title }} Materias Cursando Actual
              </h2>

              <v-card class="rounded-xl border-light overflow-hidden" elevation="0">
                <v-simple-table class="premium-table bg-transparent">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left font-weight-bold text-uppercase text-caption">Materia</th>
                        <th class="text-left font-weight-bold text-uppercase text-caption">Parcial 1</th>
                        <th class="text-left font-weight-bold text-uppercase text-caption">Parcial 2</th>
                        <th class="text-left font-weight-bold text-uppercase text-caption">Recuperatorio</th>
                        <th class="text-left font-weight-bold text-uppercase text-caption">Examen Final</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="notaData in materias" :key="notaData.materia_id" class="hover-row">
                        <td class="font-weight-bold primary-text">{{ notaData.materiaName }}</td>
                        <td>
                          <v-chip small :color="getNotaColor(notaData.parcial1)" class="font-weight-bold px-3">
                            {{ notaData.parcial1 ?? "no aplica" }}
                          </v-chip>
                        </td>
                        <td>
                          <v-chip small :color="getNotaColor(notaData.parcial2)" class="font-weight-bold px-3">
                            {{ notaData.parcial2 ?? "no aplica" }}
                          </v-chip>
                        </td>
                        <td>
                          <v-chip small :color="getNotaColor(notaData.recuperatorio)" class="font-weight-bold px-3">
                            {{ notaData.recuperatorio ?? "no aplica" }}
                          </v-chip>
                        </td>
                        <td>
                          <v-chip small :color="getNotaColor(notaData.nota || notaData.nota_equivalencia)" class="font-weight-bold px-3">
                            {{ notaData.nota || notaData.nota_equivalencia || "no aplica" }}
                          </v-chip>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card>
            </div>

            <!-- Notas por Curso -->
            <div v-for="(curso, indexCurso) in notas" :key="'curso-'+indexCurso" class="mb-8">
              <h2 class="text-h6 font-weight-bold primary-text mb-4">
                <v-icon color="primary" class="mr-2">mdi-school</v-icon>
                {{ title }} {{ indexCurso }}
              </h2>

              <v-card class="rounded-xl border-light overflow-hidden" elevation="0">
                <v-simple-table class="premium-table bg-transparent">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left font-weight-bold text-uppercase text-caption">Materia</th>
                        <th class="text-left font-weight-bold text-uppercase text-caption">Parcial 1</th>
                        <th class="text-left font-weight-bold text-uppercase text-caption">Parcial 2</th>
                        <th class="text-left font-weight-bold text-uppercase text-caption">Recuperatorio</th>
                        <th class="text-left font-weight-bold text-uppercase text-caption">Examen Final</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(notaData, idx) in curso" :key="'nota-'+notaData.id_materia+'-'+idx" class="hover-row">
                        <td class="font-weight-bold primary-text">{{ notaData.nombre_materia }}</td>
                        <td>
                          <v-chip small :color="getNotaColor(notaData.parcial1)" class="font-weight-bold px-3">
                            {{ notaData.parcial1 ?? "no aplica" }}
                          </v-chip>
                        </td>
                        <td>
                          <v-chip small :color="getNotaColor(notaData.parcial2)" class="font-weight-bold px-3">
                            {{ notaData.parcial2 ?? "no aplica" }}
                          </v-chip>
                        </td>
                        <td>
                          <v-chip small :color="getNotaColor(notaData.recuperatorio)" class="font-weight-bold px-3">
                            {{ notaData.recuperatorio ?? "no aplica" }}
                          </v-chip>
                        </td>
                        <td>
                          <v-chip small :color="getEstadoColor(notaData.estado_final)" class="font-weight-bold px-3" :text-color="getEstadoTextColor(notaData.estado_final)">
                            {{ notaData.estado_final || "no aplica" }}
                          </v-chip>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card>
            </div>

          </div>
        </v-card>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>

<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "Nota",
  components: {
    CardIeaAppMain
  },

  data: () => ({
    title: "Notas",
    notas: [],
    materias: []
  }),

  mounted() {
    this.getMaterias();
    if (
      this.$store.getters.user.borrado == 1 ||
      this.$store.getters.user.alumno_mora == true ||
      this.$store.getters.user.excedente
    ) {
      this.$router.push({
        name: "Home"
      });
    }
    this.$API
      .get({
        url: "examenes/notas"
      })
      .then(res => {
        this.notas = res;
      });
  },

  methods: {
    getMaterias() {
      if (
        this.$store.getters.user.borrado == 1 ||
        this.$store.getters.user.alumno_mora == true ||
        this.$store.getters.user.excedente
      ) {
        this.$router.push({
          name: "Home"
        });
      }
      this.$API
        .get({
          url: "materias",
          data: {}
        })
        .then(res => {
          this.materias = res;
        });
    },

    getNotaColor(nota) {
      try {
        if (nota === null || nota === undefined || nota === "no aplica" || nota === "N/A" || nota === "") return 'grey lighten-4';
        let n = parseFloat(nota);
        if (isNaN(n)) return 'grey lighten-4';
        if (n >= 7) return 'success lighten-4 success--text text--darken-2';
        if (n >= 4) return 'info lighten-4 info--text text--darken-2';
        return 'error lighten-4 error--text text--darken-2';
      } catch (e) {
        return 'grey lighten-4';
      }
    },

    getEstadoColor(estado) {
      try {
        if (!estado || estado === "no aplica" || estado === "N/A") return 'grey lighten-4';
        let e = estado.toString().toLowerCase();
        if (e.includes("aprob")) return 'success lighten-4';
        if (e.includes("regular")) return 'info lighten-4';
        if (e.includes("libre") || e.includes("reprob") || e.includes("desaprob")) return 'error lighten-4';
        return 'grey lighten-4';
      } catch (e) {
        return 'grey lighten-4';
      }
    },

    getEstadoTextColor(estado) {
      try {
        if (!estado || estado === "no aplica" || estado === "N/A") return 'grey--text text--darken-1';
        let e = estado.toString().toLowerCase();
        if (e.includes("aprob")) return 'success--text text--darken-2';
        if (e.includes("regular")) return 'info--text text--darken-2';
        if (e.includes("libre") || e.includes("reprob") || e.includes("desaprob")) return 'error--text text--darken-2';
        return 'grey--text text--darken-1';
      } catch (e) {
        return 'grey--text text--darken-1';
      }
    }
  }
};
</script>

<style scoped>
/* Glassmorphism Classes (Premium UI) */
.nota-container {
  background: transparent !important;
  min-height: calc(100vh - 120px);
}

.glass-panel {
  background: rgba(255, 255, 255, 0.7) !important;
  backdrop-filter: blur(16px) !important;
  -webkit-backdrop-filter: blur(16px) !important;
  border: 1px solid rgba(255, 255, 255, 0.5) !important;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.05) !important;
  border-radius: 20px;
  padding: 24px;
}

.glass-card {
  background: rgba(255, 255, 255, 0.85) !important;
  backdrop-filter: blur(16px) !important;
  -webkit-backdrop-filter: blur(16px) !important;
  border: 1px solid rgba(255, 255, 255, 0.4) !important;
}

.glass-btn {
  background: rgba(25, 118, 210, 0.1) !important;
  backdrop-filter: blur(4px) !important;
  box-shadow: none !important;
  transition: all 0.3s ease;
}
.glass-btn:hover {
  background: rgba(25, 118, 210, 0.2) !important;
  transform: translateY(-2px);
}

.bg-light { background-color: #f8fafc !important; }
.bg-light-gradient { background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%); }
.bg-transparent { background-color: transparent !important; }

.border-light { border: 1px solid rgba(0, 0, 0, 0.05) !important; }

/* Premium Table Styles */
.premium-table {
  border-radius: 16px;
  overflow: hidden;
}
.premium-table >>> table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}
.premium-table >>> th {
  background-color: #f8fafc;
  color: #64748b !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05) !important;
  padding: 16px !important;
}
.premium-table >>> td {
  padding: 16px !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.02) !important;
}

.hover-row {
  transition: background-color 0.2s ease;
}
.hover-row:hover {
  background-color: #f1f5f9 !important;
}

.primary-text { color: #1e293b; }
.opacity-30 { opacity: 0.3; }
</style>
